import { type FC, type PropsWithChildren, createContext, useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { DEVICE_CODE_KEY } from '../hooks/useDevice';

interface IDeviceContext {
  deviceCode: string
  setDeviceCode: (id: string) => void
  unathorized?: boolean
}

export const DeviceContext = createContext<IDeviceContext>({
  deviceCode: 'null',
  setDeviceCode: () => { },
  unathorized: false
});

const exceptionEmails = [
  'brumaycolchon@gmail.com',
  'erpoba@gmail.com',
  'xaviamengualq@gmail.com'
];

export const DeviceProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();

  const [deviceCode, setDeviceCode] = useState('');
  const [unathorized, setUnauthorized] = useState<boolean>(true);

  useEffect(() => {
    const id = localStorage.getItem(DEVICE_CODE_KEY);

    setDeviceCode(id!);
  }, []);

  useEffect(() => {
    if (!user) return;
    if (user && user.role?.name === 'user') {
      const deviceToBeSet = !user?.devices || user.devices.length === 0;
      const tokenIsInDevices = user.devices?.includes(deviceCode);

      if (tokenIsInDevices || (deviceToBeSet) || (exceptionEmails.includes(user.email.toLowerCase()))) {
        setUnauthorized(false);
      }
    } else {
      setUnauthorized(false);
    }
  }, [deviceCode, user]);

  console.log('unathorized', unathorized);

  return (
    <DeviceContext.Provider value={{ deviceCode, setDeviceCode, unathorized }}>
      {children}
    </DeviceContext.Provider>

  );
};
